module.exports = __webpack_public_path__ + "static/media/muvn_banner.37c44f2d.png";